(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("candidateNotesService", CandidateNotesService);

    CandidateNotesService.$inject = ['$q'];

    function CandidateNotesService($q) {

        var self = this;
        var _emitter = JarEventEmitter.call(self);
        var brandsTrees = {};
        var brandsInfo = {};

        self.EVENTS = {
            ON_NOTE_CREATED: "ON_NOTE_CREATED"
        };

        self.getCandidateNotes = function (brandId, candidateId) {
            var defer = $q.defer();

            NotesAPI
                .getCandidateNotes(brandId, candidateId)
                .then(function (result) {
                    defer.resolve(result);
                }, function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.createCandidateNote = function (brandId, params) {
            var defer = $q.defer();

            NotesAPI
                .createCandidateNote(brandId, params)
                .then(function (result) {
                    _emitter.trigger(self.EVENTS.ON_NOTE_CREATED, result);
                    defer.resolve(result);
                }, function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.loadBrandTree = function (brandId) {
            var defer = $q.defer();

            if (brandsTrees[brandId]) {
                defer.resolve(brandsTrees[brandId]);
            } else {
                BrandAPI.getBrandsTree(brandId)
                    .then(function (tree) {
                        brandsTrees[brandId] = tree;
                        defer.resolve(tree);
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    });
            }
            return defer.promise;
        };

        self.getBrandBasicInfo = function (brandId) {
            var defer = $q.defer();

            if (brandsInfo[brandId]) {
                defer.resolve(brandsInfo[brandId]);
            } else {
                BrandAPI.getBrandBasicInfo(brandId)
                    .then(function (brandInfo) {
                        brandsInfo[brandId] = brandInfo;
                        defer.resolve(brandInfo);
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    });
            }
            return defer.promise;
        };

        return self;
    }
}());